export const SEARCH_RESULT_GROUP_PEOPLE: string = 'people';
export const SEARCH_RESULT_GROUP_COMPANIES: string = 'companies';
export const SEARCH_RESULT_GROUP_DEALS: string = 'deals';
export const SEARCH_RESULT_GROUP_DEALS_CLOSED: string = 'deals-closed';
export const SEARCH_RESULT_GROUP_ASSETS: string = 'assets';
export const SEARCH_RESULT_GROUP_ACTIVITIES: string = 'activities';
export const SEARCH_RESULT_GROUP_DEAL_TASKS: string = 'deal-tasks';

export const SEARCH_RESULT_GROUP_LIST: SearchResultGroup[] = [
  {
    id: 1,
    name: SEARCH_RESULT_GROUP_PEOPLE,
    title: 'People',
  },
  {
    id: 2,
    name: SEARCH_RESULT_GROUP_COMPANIES,
    title: 'Companies',
  },
  {
    id: 3,
    name: SEARCH_RESULT_GROUP_DEALS,
    title: 'Deals',
  },
  {
    id: 4,
    name: SEARCH_RESULT_GROUP_DEALS_CLOSED,
    title: 'Deals Closed',
  },
  {
    id: 5,
    name: SEARCH_RESULT_GROUP_ASSETS,
    title: 'Assets',
  },
  {
    id: 6,
    name: SEARCH_RESULT_GROUP_ACTIVITIES,
    title: 'Activities',
  },
  {
    id: 7,
    name: SEARCH_RESULT_GROUP_DEAL_TASKS,
    title: 'Deal Tasks',
  },
];
